import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { EYELASHES } from 'Root/constants';
import { EyeLashes, ColorShade } from 'Components/commonComponents';
import AppContext from 'Components/context';
import VmContext from 'Components/virtualMirror/context';
import { ClickLayer } from '../../../../ga4';

export default function ShadesList({ shades, type, handleShadeChange }) {
  const appContext = useContext(AppContext);
  const { selectedLensType, selectedTab } = useContext(VmContext);
  const {
    makeupCleared,
    updateMakeupCleared,
    updateSelectedShadesSet,
    selectedShadesSet,
    isLensChanged,
    clearState,
    lensCleared,
  } = appContext;
  const [selectedShade, setSelectedShade] = useState('');

  useEffect(() => {
    // update makeup when already shades are selected
    if (!isLensChanged && !lensCleared) {
      Object.keys(selectedShadesSet).forEach((el) => {
        if (selectedShadesSet[el]) {
          handleShadeChange(selectedShadesSet[el], el);
        }
      });
    } else {
      clearState('selectedShadesSet');
    }
  }, [isLensChanged, lensCleared]);

  const shadeHandler = (shade) => () => {
    const { skuId } = shade;
    ClickLayer('JPshadeclick');

    updateSelectedShadesSet(skuId, type);
    setSelectedShade(skuId);
    handleShadeChange(skuId, type);
    updateMakeupCleared(false);
  };

  const setClassName = (shade) => {
    const { skuId } = shade;

    const isActive =
      (selectedShade === skuId || selectedShadesSet[type] === skuId) &&
      !makeupCleared &&
      !isLensChanged;

    return isActive ? ` shades--item active` : 'shades--item';
  };

  return (
    <ul className={`shades shades--${type} ${selectedLensType} ${selectedTab}`}>
      {shades.map((shade) => {
        const { img, skuId } = shade;

        return (
          <li
            key={skuId}
            onClick={shadeHandler(shade)}
            className={setClassName(shade)}
          >
            {type === EYELASHES ? (
              <EyeLashes imageName={img} isCustomeMakeup={true} /> // Image name = skuId
            ) : (
              <ColorShade colorCode={shade.color_code} />
            )}
          </li>
        );
      })}
    </ul>
  );
}

ShadesList.propTypes = {
  shades: PropTypes.array.isRequired,
  type: PropTypes.string.isRequired,
  handleShadeChange: PropTypes.func.isRequired,
};
